import React from 'react'
import * as routes from 'core/routing/constants'
import { FormattedMessage } from 'react-intl'
import { isMobile } from 'react-device-detect'
import Vehicle from './vehicle'
import VehicleConfirm from './vehicle-confirm'
import Colors from './colors'
import Options from './options'
import State from './state'
import Defaults from './defaults'
import Historical from './historical'
import Distributor from './distributor'
//import FutherInformations from './futher-informations'
import Contact from './contact'
import Estimate from './estimate'
import { REFERENTIAL_AUTOBIZ } from '../core/utils/enums/referential'

// Disributor at the begining
export const aStepsTradeInConfig1 = configuration =>
  [
    {
      hash: routes.TRADEIN_DISTRIBUTOR,
      data: { hash: routes.TRADEIN_DISTRIBUTOR, isActive: true, isStepPrincipal: true },
      cssId: 'globaldealer-title-12',
      title: <FormattedMessage id="tradein-wizard-title-1" />,
      component: <Distributor />,
      nextButtonText: <FormattedMessage id="wizard-navigation-next" />
    },
    {
      hash: routes.TRADEIN_VEHICLE,
      data: {
        hash: routes.TRADEIN_VEHICLE,
        isActive: true
      },
      component: <Vehicle />,
      backButtonText: <FormattedMessage id="tradein-wizard-vehicle-backButton" />
    },
    {
      hash: routes.TRADEIN_VEHICLE_CONFIRM,
      data: {
        hash: routes.TRADEIN_VEHICLE_CONFIRM,
        isActive: false
      },
      component: <VehicleConfirm />,
      backButtonText: isMobile ? (
        <FormattedMessage id="theming-wizard-view2-backButton" />
      ) : (
        <FormattedMessage id="tradein-wizard-vehicle-confirm-backButton" />
      ),
      nextButtonText: isMobile ? (
        <FormattedMessage id="wizard-navigation-next" />
      ) : (
        <FormattedMessage id="tradein-wizard-vehicle-confirm-nextButton" />
      )
    },
    {
      hash: routes.TRADEIN_COLORS,
      data: {
        hash: routes.TRADEIN_COLORS,
        isActive: false
      },
      component: <Colors />,
      backButtonText: <FormattedMessage id="tradein-wizard-vehicle-backButton" />,
      nextButtonText: <FormattedMessage id="wizard-navigation-next" />
    },
    configuration !== REFERENTIAL_AUTOBIZ && {
      hash: routes.TRADEIN_OPTIONS,
      data: {
        hash: routes.TRADEIN_OPTIONS,
        isActive: false
      },
      component: <Options />,
      backButtonText: <FormattedMessage id="tradein-wizard-vehicle-backButton" />,
      nextButtonText: <FormattedMessage id="wizard-navigation-next" />
    },
    {
      hash: routes.TRADEIN_HISTORICAL,
      data: {
        hash: routes.TRADEIN_HISTORICAL,
        isActive: false
      },
      component: <Historical />,
      backButtonText: <FormattedMessage id="tradein-wizard-vehicle-backButton" />,
      nextButtonText: <FormattedMessage id="wizard-navigation-next" />
    },
    {
      hash: routes.TRADEIN_STATE,
      data: {
        hash: routes.TRADEIN_STATE,
        isActive: false,
        isStepPrincipal: true
      },
      title: <FormattedMessage id="tradein-wizard-title-2" />,
      component: <State />,
      backButtonText: <FormattedMessage id="tradein-wizard-vehicle-backButton" />,
      nextButtonText: <FormattedMessage id="wizard-navigation-next" />
    },
    {
      hash: routes.TRADEIN_DEFAULTS,
      data: {
        hash: routes.TRADEIN_DEFAULTS,
        isActive: false
      },
      component: <Defaults />,
      backButtonText: <FormattedMessage id="tradein-wizard-vehicle-backButton" />,
      nextButtonText: <FormattedMessage id="wizard-navigation-next" />
    },
    {
      hash: routes.TRADEIN_CONTACT,
      data: {
        hash: routes.TRADEIN_CONTACT,
        isActive: false,
        isStepPrincipal: true
      },
      title: <FormattedMessage id="tradein-wizard-title-3" />,
      component: <Contact />,
      backButtonText: <FormattedMessage id="tradein-wizard-vehicle-backButton" />,
      nextButtonText: <FormattedMessage id="tradein-wizard-contact-nextButton" />
    },
    {
      hash: routes.TRADEIN_ESTIMATE,
      data: {
        hash: routes.TRADEIN_ESTIMATE,
        isActive: false,
        isStepPrincipal: true
      },
      title: <FormattedMessage id="tradein-wizard-title-4" />,
      component: <Estimate />
    }
  ].filter(Boolean)

// Disributor at the end
export const aStepsTradeInConfig2 = configuration =>
  [
    {
      hash: routes.TRADEIN_VEHICLE,
      data: {
        hash: routes.TRADEIN_VEHICLE,
        isActive: true,
        isStepPrincipal: true
      },
      cssId: 'globaldealer-title-12',
      title: <FormattedMessage id="tradein-wizard-title-1" />,
      component: <Vehicle />
    },
    {
      hash: routes.TRADEIN_VEHICLE_CONFIRM,
      data: {
        hash: routes.TRADEIN_VEHICLE_CONFIRM,
        isActive: false
      },
      component: <VehicleConfirm />,
      backButtonText: isMobile ? (
        <FormattedMessage id="theming-wizard-view2-backButton" />
      ) : (
        <FormattedMessage id="tradein-wizard-vehicle-confirm-backButton" />
      ),
      nextButtonText: isMobile ? (
        <FormattedMessage id="wizard-navigation-next" />
      ) : (
        <FormattedMessage id="tradein-wizard-vehicle-confirm-nextButton" />
      )
    },
    {
      hash: routes.TRADEIN_COLORS,
      data: {
        hash: routes.TRADEIN_COLORS,
        isActive: false
      },
      component: <Colors />,
      backButtonText: <FormattedMessage id="tradein-wizard-vehicle-backButton" />,
      nextButtonText: <FormattedMessage id="wizard-navigation-next" />
    },
    configuration !== REFERENTIAL_AUTOBIZ && {
      hash: routes.TRADEIN_OPTIONS,
      data: {
        hash: routes.TRADEIN_OPTIONS,
        isActive: false
      },
      component: <Options />,
      backButtonText: <FormattedMessage id="tradein-wizard-vehicle-backButton" />,
      nextButtonText: <FormattedMessage id="wizard-navigation-next" />
    },
    {
      hash: routes.TRADEIN_HISTORICAL,
      data: {
        hash: routes.TRADEIN_HISTORICAL,
        isActive: false
      },
      component: <Historical />,
      backButtonText: <FormattedMessage id="tradein-wizard-vehicle-backButton" />,
      nextButtonText: <FormattedMessage id="wizard-navigation-next" />
    },
    {
      hash: routes.TRADEIN_STATE,
      data: {
        hash: routes.TRADEIN_STATE,
        isActive: false,
        isStepPrincipal: true
      },
      title: <FormattedMessage id="tradein-wizard-title-2" />,
      component: <State />,
      backButtonText: <FormattedMessage id="tradein-wizard-vehicle-backButton" />,
      nextButtonText: <FormattedMessage id="wizard-navigation-next" />
    },
    {
      hash: routes.TRADEIN_DEFAULTS,
      data: {
        hash: routes.TRADEIN_DEFAULTS,
        isActive: false
      },
      component: <Defaults />,
      backButtonText: <FormattedMessage id="tradein-wizard-vehicle-backButton" />,
      nextButtonText: <FormattedMessage id="wizard-navigation-next" />
    },
    {
      hash: routes.TRADEIN_DISTRIBUTOR,
      data: {
        hash: routes.TRADEIN_DISTRIBUTOR,
        isActive: true,
        isStepPrincipal: true
      },
      title: <FormattedMessage id="tradein-wizard-title-3" />,
      component: <Distributor />,
      nextButtonText: <FormattedMessage id="wizard-navigation-next" />
    },
    {
      hash: routes.TRADEIN_CONTACT,
      data: {
        hash: routes.TRADEIN_CONTACT,
        isActive: false
      },
      component: <Contact />,
      backButtonText: <FormattedMessage id="tradein-wizard-vehicle-backButton" />,
      nextButtonText: <FormattedMessage id="tradein-wizard-contact-nextButton" />
    },
    {
      hash: routes.TRADEIN_ESTIMATE,
      data: {
        hash: routes.TRADEIN_ESTIMATE,
        isActive: false,
        isStepPrincipal: true
      },
      title: <FormattedMessage id="tradein-wizard-title-4" />,
      component: <Estimate />
    }
  ].filter(Boolean)
